var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import { alias } from '@ember/object/computed';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
let Address = (_dec = attr('string', {
  defaultValue: CatalogObjectType.ADDRESS,
  protoEnum: CatalogObjectTypeProto
}), _dec2 = fragment('connect/address/data'), _dec3 = alias('addressData.address.addressLine1'), _dec4 = alias('addressData.address.addressLine2'), _dec5 = alias('addressData.address.addressLine3'), _dec6 = alias('addressData.address.locality'), _dec7 = alias('addressData.address.sublocality'), _dec8 = alias('addressData.address.sublocality2'), _dec9 = alias('addressData.address.sublocality3'), _dec10 = alias('addressData.address.administrativeDistrictLevel1'), _dec11 = alias('addressData.address.administrativeDistrictLevel2'), _dec12 = alias('addressData.address.administrativeDistrictLevel3'), _dec13 = alias('addressData.address.postalCode'), _dec14 = alias('addressData.address.country'), _dec15 = alias('addressData.address.firstName'), _dec16 = alias('addressData.address.lastName'), _dec17 = alias('addressData.address.organization'), _dec18 = alias('addressData.coordinates.latitude'), _dec19 = alias('addressData.coordinates.longitude'), _class = (_class2 = class Address extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "addressData", _descriptor2, this);
    _initializerDefineProperty(this, "addressLine1", _descriptor3, this);
    _initializerDefineProperty(this, "addressLine2", _descriptor4, this);
    _initializerDefineProperty(this, "addressLine3", _descriptor5, this);
    _initializerDefineProperty(this, "locality", _descriptor6, this);
    _initializerDefineProperty(this, "sublocality", _descriptor7, this);
    _initializerDefineProperty(this, "sublocality2", _descriptor8, this);
    _initializerDefineProperty(this, "sublocality3", _descriptor9, this);
    _initializerDefineProperty(this, "administrativeDistrictLevel1", _descriptor10, this);
    _initializerDefineProperty(this, "administrativeDistrictLevel2", _descriptor11, this);
    _initializerDefineProperty(this, "administrativeDistrictLevel3", _descriptor12, this);
    _initializerDefineProperty(this, "postalCode", _descriptor13, this);
    _initializerDefineProperty(this, "country", _descriptor14, this);
    _initializerDefineProperty(this, "firstName", _descriptor15, this);
    _initializerDefineProperty(this, "lastName", _descriptor16, this);
    _initializerDefineProperty(this, "organization", _descriptor17, this);
    _initializerDefineProperty(this, "latitude", _descriptor18, this);
    _initializerDefineProperty(this, "longitude", _descriptor19, this);
  }
  isValidAddress() {
    if (this.country === 'FR') {
      if (!this.addressLine1 || !this.locality || !this.postalCode) {
        return false;
      }
    } else {
      if (!this.addressLine1 || !this.locality || !this.postalCode || !this.administrativeDistrictLevel1 || !this.country) {
        return false;
      }
    }
    return true;
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/address'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "addressData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "addressLine1", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "addressLine2", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "addressLine3", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "locality", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "sublocality", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "sublocality2", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "sublocality3", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "administrativeDistrictLevel1", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "administrativeDistrictLevel2", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "administrativeDistrictLevel3", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "postalCode", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "country", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "firstName", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "lastName", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "organization", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "latitude", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "longitude", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Address as default };